module.exports = __webpack_public_path__ + "img/per-minute.dadbe71c.svg";